import { motion } from "framer-motion";
import { STEPS } from "@/data/services";
import { TID } from "@/constants/testIds/site";

export default function Process() {
  return (
    <section
      id="process"
      data-testid={TID.process.section}
      className="relative py-28 md:py-36 px-6 md:px-10 border-t border-white/5"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5">
            <div className="text-[11px] uppercase tracking-[0.4em] text-white/50 mb-4 flex items-center gap-3">
              <span className="dot-gold" />
              Comment ça marche
            </div>
            <h2 className="font-display text-5xl md:text-7xl tracking-tighter text-white leading-[0.9]">
              Simple. <br />
              <span className="text-gold-gradient italic">Rapide.</span> <br />
              Efficace.
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex items-end">
            <p className="text-white/60 text-lg leading-relaxed">
              De la sélection du pack au lancement de votre campagne, tout est
              conçu pour vous faire gagner du temps — et surtout,{" "}
              <span className="text-white">des clients</span>.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-0 border-t border-white/10">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className={`p-8 md:p-10 border-b md:border-b-0 border-white/10 ${
                i < 3 ? "md:border-r md:border-white/10" : ""
              } hover:bg-white/[0.02] transition-colors`}
            >
              <div className="font-display text-6xl text-gold-gradient tracking-tighter">
                {s.n}
              </div>
              <div className="text-white font-semibold text-lg mt-6">
                {s.title}
              </div>
              <div className="text-white/55 text-sm mt-3 leading-relaxed">
                {s.desc}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
